/** Stroke icons for table row actions — 20×20 viewBox, matches NavIcons */
export function IconEdit(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <path
        d="M11.5 4.5 15 8 6.5 16.5H3v-3.5L11.5 4.5Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M9 7l4 4"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconTrash(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <path
        d="M6.5 7.5V15a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7.5M8.5 7.5V5h3v2.5M4 7.5h12"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Indeterminate progress — pair with `.action-icon--spin` */
export function IconSpinner(props) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
      <circle
        cx="10"
        cy="10"
        r="7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="11 44"
      />
    </svg>
  );
}
